import { useEffect } from "react";
import { History } from "lucide-react";
import { Empty } from "@/components/shared";
import { fdt, useApi } from "@/lib/api";

export function AuditList({ entityType, entityId, refreshKey }) {
  const { data, reload } = useApi(`/audit?entityType=${entityType}&entityId=${entityId}`);
  useEffect(() => { if (refreshKey) reload(); }, [refreshKey, reload]);
  if (data && !data.length) return <Empty text="No activity recorded yet." />;
  return (
    <div className="rounded-lg border bg-card divide-y" data-testid="audit-log-list">
      {data?.map((a) => (
        <div key={a.id} className="flex gap-3 px-5 py-3 text-sm">
          <History className="h-4 w-4 text-muted-foreground mt-0.5 shrink-0" />
          <div className="flex-1 min-w-0">
            <div><span className="font-medium">{a.userName}</span> <span className="text-muted-foreground">·</span> {a.action}</div>
            {Object.keys(a.details || {}).length > 0 && (
              <div className="text-xs text-muted-foreground mt-0.5 break-words">
                {Object.entries(a.details).map(([k, v]) => `${k}: ${typeof v === "object" ? JSON.stringify(v) : v === "" ? "—" : v}`).join(" · ")}
              </div>
            )}
          </div>
          <div className="text-xs text-muted-foreground whitespace-nowrap font-mono">{fdt(a.createdAt)}</div>
        </div>
      ))}
    </div>
  );
}
